import { RenderOptions } from '../../common/zoom/models/render-options';

export const POS_PREFIX = 'f';
export const TITLED_CIRCLE_RADIUS = `${POS_PREFIX}r`;
export const MAIN_DEPTH = 1;

/**
 * ZOOM
 */
export const ZOOM_RANGE = [0.1, 20];

/**
 * FONTS
 */

export const FONT_SIZE_RANGE = [14, 20];
export const FONT_SIZE_TOOLTIP = 14;
export const FONT_SIZE_TOOLTIP_IDEAL = 5;
export const FONT_SIZE_VALUE = 0.7;

/**
 * COLORS
 */

export const TEXT_LABEL = '#3E4D63';
export const TEXT_VALUE = '#8A9BAB';

/**
 * ALPHA COLORS
 */

export const ALPHA_FILL_CIRCLE = 0.2;
export const ALPHA_FILL_CIRCLE_MAIN_LEVEL = 0.1;
export const ALPHA_STROKE_CIRCLE = 0.2;

/**
 * STROKES
 */
export const STROKE_CIRCLE = 1;
export const STROKE_CIRCLE_UI = 2;
export const STROKE_CIRCLE_UI_IDEAL = 1;
export const STROKE_TOOLTIP = 10;
export const STROKE_TOOLTIP_IDEAL = 2;

/**
 * PADDING
 */

export const RELATIVE_PADDING_MAIN_CIRCLE = 0.05; // 0 - 1 where 1 is the entire radius
export const PADDING_TOOLTIP = 5;
export const ZOOM_PADDING = 30;

export const PADDING_PERCENTAGE_COLLISION = 1.05;
export const PADDING_CIRCLE_PARENT = 1.05;
export const PADDING_CIRCLE_PARENT_ONLY_ONE_CHILD = 1.3;

/**
 * OFFSET
 */
export const TITLE_OFFSET = 60;
/**
 * BORDER RADIUS
 */

export const BORDER_RADIUS_TOOLTIP = 5;

/**
 * STATES
 */
export const SHOW_TOP_TITLE_CIRCLE = false;

/**
 * TEXT
 */

export const TEXT_ALIGN_LABEL = 'center';
export const TEXT_BASELINE_LABEL = 'middle';

/**
 * RADIUS
 */

export const RANGE_RADIUS = [20, 100];

/**
 * DEFAULT RENDER OPTIONS
 */
export const DEFAULT_RENDER_OPTIONS: RenderOptions = {
  circles: {
    renderDepth: 2
  },
  text: {
    renderValue: true
  }
};

/*

  CANVAS SIZE
*/
export const CANVAS_HEIGHT = 565;
